import { FeedType } from '@pushly/aqe/lib/enums/index'
import { StatusType } from '@pushly/aqe/lib/enums'
import { IFeedConfiguration } from '@pushly/aqe/lib/interfaces/index'

export class FeedDto {
    public static fromApiResponse(fields: Partial<FeedDto>): FeedDto {
        const dto = new FeedDto()
        Object.assign(dto, fields)
        return dto
    }

    public id: number
    public domain_id: number
    public name: string
    public feed_type: FeedType
    public url: string
    public enabled: boolean
    public status_id: StatusType
    public segment_ids: number[]
    public excluded_segment_ids: number[]
    public config: IFeedConfiguration

    public segments: any[]

    public excluded_segments: any[]
    public created_at: string
    public created_by: string
    public updated_by: string
}
